module.exports = __webpack_public_path__ + "static/ControlEvents-001d81a9b2ef5f986d6305a75fad7d8a.png";